/*
 * @Author: your name
 * @Date: 2021-04-27 13:49:19
 * @LastEditTime: 2021-05-04 12:00:18
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \yijiu_shopmall_h5\http.js
 */
// import url from './config.js';
import axios from 'axios';
import { weixinFg } from '@/public/public'//微信授权
import payInfo from './config'
import store from "./src/store";
let instance = axios.create({
  baseURL: payInfo.payUrl,
  // baseURL: 'https://merchant-api.yijiudingdong.com/api',
  method: 'post',
  headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
  timeout: 60000000,
});
instance.interceptors.request.use(function (config) {
  // 在发送请求之前做些什么
  return config;
}, function (error) {
  // 对请求错误做些什么
  return Promise.reject(error);
});

instance.interceptors.response.use(function (response) {
  console.log(response)
  console.log(response.data.content)
  if (response.config.data.indexOf('Base.wxLogin') && response.data.content && response.data.content.token && response.data.status != 600) {
    localStorage.setItem('token', response.data.content.token)
    localStorage.setItem('isToken', response.data.content.token ? true : false)
    localStorage.setItem('member_id', response.data.content.id)
    localStorage.setItem('userInfo', JSON.stringify(response.data.content))
  }
  // 对响应数据做点什么
  return response;
}, function (error) {
  // 对响应错误做点什么
  return Promise.reject(error);
});
// 添加请求拦截器
let http = function (url, params) {
  let data = {
    "content": {
      "base": {
        "time": '121212121212',
        "source": "4",
        "equipment": "苹果7",
        "token": params.token,
        "version": "v1.0"
      },
      "data": {
        "method": url,
        ...params
      }
    },
    "lock": "",
    "time": "121212121212",
    "app_key": "7ab4bcfc-adf6-11e9-af3f-0800274e100a"
  }
  let request = 'post'
  return new Promise((resolu, rejec) => {
    instance[request]('', data).then((res) => {
      console.log(res.data.status)
      if (res.data.status == 100 || res.data.status == 1034) {//100 状态失效 1034 
        store.commit('LoginFailure', true)
        return false
      };
      resolu(res.data)
    }).catch((err) => {
      rejec(err)
    })
  })
}

export default http